import { useI18n } from '@change-corgi/core-react/i18n';

import { useModalConfirmationContext } from '#src/app/shared/hooks/payments';

import { usePromoteFormData, usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<
	{
		text: string | React.JSX.Element | React.JSX.Element[];
		cancelLabel: string;
		confirmLabel: string;
		ariaLabel: string;
		showHighAmountConfirmationModal: boolean;
	},
	{
		confirmPromotionHighAmount: () => void;
		cancelHighAmountConfirmation: () => void;
	}
>;

export function useHighAmountConfirmationModal(): Result {
	const {
		currency: { code },
	} = usePromoteFormData();
	const [{ amount }] = usePromoteFormState();
	const { translate, translateHtml, localizeCurrency } = useI18n();
	const [{ modalOptions }, { handleModalResult }] = useModalConfirmationContext();

	return {
		data: {
			text:
				// TODO: Move this i8n key to corgi namespace
				translateHtml('fe.pages.sponsors.confirm_high_amount_payment.modal_body', {
					amount: `<strong>${localizeCurrency(amount, code, { forceFractionDigits: true })}</strong>`,
				}),
			// TODO: Move these i8n keys to corgi namespace
			cancelLabel: translate('fe.pages.sponsors.confirm_high_amount_payment.cancel'),
			confirmLabel: translate('fe.pages.sponsors.confirm_high_amount_payment.continue'),
			ariaLabel: translate('corgi.co.promote.high_amount_confirmation_modal.aria_label'),
			showHighAmountConfirmationModal: modalOptions?.type === 'highAmount',
		},
		actions: {
			confirmPromotionHighAmount: () => handleModalResult(true),
			cancelHighAmountConfirmation: () => handleModalResult(false),
		},
	};
}
